<div *ngIf="publicUrl">
    <div class="modal-header">
        <h1 class="modal-title" *ngIf="title">{{title}}</h1>
        <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()">
        </button>
    </div>
    <div class="modal-body">
        <iframe id="modaliframe" frameborder="0" width="100%" height="100%" [src]="publicUrl"
            style="min-height:540px;"></iframe>
    </div>
</div>